import type { PropsWithChildren } from "react";
import { Link } from "react-router";

export function Shell({
  children,
  dark = false,
  accountMode = "public",
}: PropsWithChildren<{ dark?: boolean; accountMode?: "public" | "contractor" }>) {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_#dff3ed_0,_transparent_35%),linear-gradient(180deg,#fbfbf7_0%,#f1f0e8_100%)]">
      <header
        className={`sticky top-0 z-40 border-b backdrop-blur-xl ${dark ? "border-white/10 bg-[#071713]/95 text-white" : "border-stone-200/80 bg-white/90"}`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6">
          <Link
            to="/"
            className={`flex items-center gap-3 font-bold ${dark ? "text-white" : "text-emerald-950"}`}
          >
            <span className="h-10 w-10 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm">
              <img
                alt=""
                aria-hidden="true"
                className="h-full w-full object-cover"
                src="/brand/mziq-icon.png"
              />
            </span>
            <span className="hidden text-lg tracking-[-0.02em] sm:inline">Mezoniq</span>
          </Link>
          <nav
            className={`flex items-center gap-2 text-xs font-semibold sm:gap-3 sm:text-sm ${dark ? "text-stone-200" : "text-stone-700"}`}
          >
            {accountMode === "contractor" ? (
              <Link
                className={`rounded-full border px-3 py-2 transition sm:px-4 ${dark ? "border-white bg-white text-stone-950 hover:bg-stone-200" : "border-stone-300 bg-white hover:border-emerald-700 hover:text-emerald-800"}`}
                to="/contractor/dashboard"
              >
                Contractor dashboard
              </Link>
            ) : (
              <>
                <Link
                  className={`rounded-full px-2 py-2 transition sm:px-3 ${dark ? "hover:bg-white/10 hover:text-white" : "hover:bg-emerald-50 hover:text-emerald-800"}`}
                  to="/login?returnTo=/projects"
                >
                  Customer login
                </Link>
                <Link
                  className={`rounded-full border px-2 py-2 transition sm:px-4 ${dark ? "border-white bg-white text-stone-950 hover:bg-stone-200" : "border-stone-300 bg-white hover:border-emerald-700 hover:text-emerald-800"}`}
                  to="/login?returnTo=/contractor/projects"
                >
                  Contractor login
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>
      {children}
    </div>
  );
}
